// -- Constants
const momaxMenuDesktop = window.matchMedia('(min-width: 1200px)');

// -- Functions
class MomaxMegaMenu extends HTMLElement {
  selectCategory(index) {
    this.querySelectorAll('[data-momax-category]').forEach(button => {
      const selected = button.dataset.momaxCategory === index;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-expanded', String(selected));
      if (selected && this.querySelector('[data-momax-category-title]')) {
        this.querySelector('[data-momax-category-title]').textContent = button.firstChild.textContent;
      }
    });
    this.querySelectorAll('[data-momax-category-panel]').forEach(panel => {
      panel.hidden = panel.dataset.momaxCategoryPanel !== index;
      if (!panel.hidden) {
        const firstProduct = panel.querySelectorAll('[data-momax-detail]')[0];
        this.selectPreview(panel, firstProduct?.dataset.momaxDetail || null);
      }
    });
  }

  selectPreview(panel, index) {
    panel.querySelectorAll('[data-momax-preview]').forEach(link => link.classList.toggle('is-selected', link.dataset.momaxPreview === index));
    panel.querySelectorAll('[data-momax-detail]').forEach(detail => { detail.hidden = detail.dataset.momaxDetail !== index; });
  }

  // -- Lifecycle hooks
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    const activate = event => {
      const category = event.target.closest('[data-momax-category]');
      if (category && category.getAttribute('aria-expanded') !== 'true') this.selectCategory(category.dataset.momaxCategory);
      const product = event.target.closest('[data-momax-preview]');
      if (product) this.selectPreview(product.closest('[data-momax-category-panel]'), product.dataset.momaxPreview);
    };
    this.addEventListener('click', activate, options);
    if (this.dataset.mode === 'desktop') {
      this.addEventListener('pointerover', event => { if (event.pointerType === 'mouse') activate(event); }, options);
      this.addEventListener('focusin', activate, options);
      // Every fresh opening starts with the first product in the first category.
      this.observer = new MutationObserver(() => {
        if (!this.parentElement.hidden) this.selectCategory('1');
      });
      this.observer.observe(this.parentElement, { attributes: true, attributeFilter: ['hidden'] });
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}

class MomaxMobileMenu extends HTMLElement {
  back() {
    this.querySelectorAll('[data-momax-menu-group]').forEach(group => { group.hidden = true; });
    this.querySelector('[data-momax-menu-root]').hidden = false;
    this.opener?.setAttribute('aria-expanded', 'false');
    this.opener?.focus({ preventScroll: true });
  }

  // -- Lifecycle hooks
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('click', event => {
      const expand = event.target.closest('[data-momax-expand]');
      if (expand) {
        const opened = expand.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('[data-momax-expand]').forEach(button => {
          const active = button === expand && opened;
          button.setAttribute('aria-expanded', String(active));
          this.querySelector(`#${button.getAttribute('aria-controls')}`).hidden = !active;
        });
      }
      const opener = event.target.closest('[data-momax-open-group]');
      if (opener) {
        this.opener = opener;
        opener.setAttribute('aria-expanded', 'true');
        this.querySelector('[data-momax-menu-root]').hidden = true;
        const group = this.querySelector(`[data-momax-menu-group="${opener.dataset.momaxOpenGroup}"]`);
        group.hidden = false;
        group.querySelector('momax-mega-menu').selectCategory(opener.dataset.momaxOpenCategory);
        this.scrollTop = 0;
        group.querySelector('[data-momax-back]').focus({ preventScroll: true });
      }
      if (event.target.closest('[data-momax-back]')) this.back();
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.querySelector('[data-momax-menu-root]').hidden) {
        event.preventDefault();
        event.stopPropagation();
        this.back();
      }
    }, options);
  }

  disconnectedCallback() { this.controller?.abort(); }
}

// -- Listeners
document.addEventListener('focusin', event => {
  const link = event.target.closest('.momax-header desktop-navigation .header__linklist-link[aria-controls], .momax-header desktop-navigation .nav-dropdown__link[aria-controls]');
  if (link && link.getAttribute('aria-expanded') !== 'true') link.closest('desktop-navigation').openDropdown(link.parentElement);
});
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const nav = event.target.closest('.momax-header desktop-navigation');
  if (!nav) return;
  const item = event.target.closest('.header__linklist-item');
  const trigger = item?.querySelector('.header__linklist-link[aria-controls]');
  if (trigger) {
    trigger.focus();
    nav.closeDropdown(item);
  }
});
document.addEventListener('focusout', event => {
  const item = event.target.closest('.momax-header .header__linklist-item');
  if (item?.querySelector('.header__linklist-link[aria-controls]') && !item.contains(event.relatedTarget)) {
    item.closest('desktop-navigation').closeDropdown(item);
  }
});
momaxMenuDesktop.addEventListener('change', () => {
  const drawer = document.querySelector('.momax-mobile-menu');
  if (momaxMenuDesktop.matches && drawer?.open) drawer.open = false;
});

// -- Lifecycle hooks
if (!customElements.get('momax-mega-menu')) customElements.define('momax-mega-menu', MomaxMegaMenu);
if (!customElements.get('momax-mobile-menu')) customElements.define('momax-mobile-menu', MomaxMobileMenu);
